import safeJSONParse from 'lib/safeJSONParse.js';

const buildSchedulingContactPayload = (message = {}, contacts = []) => {
  const eventMeta = message.event_meta ? safeJSONParse(message.event_meta) : undefined;
  const scheduling = (eventMeta || {}).lead_loop_scheduling || (eventMeta || {}).leadloop_scheduling;
  const isSchedulingContact = !!(scheduling || {}).firstName;
  if (isSchedulingContact) {
    let schedulingContactName = `${scheduling.firstName || ''} ${scheduling.lastName || ''}`.trim().toLowerCase();
    let match = contacts.find((n) => {
      let nName = `${n.first_name || ''} ${n.last_name || ''}`.trim().toLowerCase();
      return nName === schedulingContactName;
    });

    const birthdayDetail = scheduling.dateOfBirth
      ? {
          detail_type_id: '7',
          detail_sub_type_id: '19',
          value: scheduling.dateOfBirth,
        }
      : undefined;
    return {
      id: (match || {}).id || undefined,
      assign_to_pipeline: true,
      first_name: scheduling.firstName,
      last_name: scheduling.lastName,
      gender: scheduling.gender === 'Female' ? 'F' : scheduling.gender === 'Male' ? 'M' : 'O',
      title: scheduling.title,
      details: [birthdayDetail].filter((n) => !!n),
    };
  }
  return undefined;
};

export default buildSchedulingContactPayload;
